import React from 'react';
import { DatePicker } from 'antd';
import { IBVControl } from '../../../models/BVControls/IBVControl';
import './bv-date-picker.scss';
import BVControl from '../BVControl/bv-control';

interface IBVDatePicker extends IBVControl {
    properties: any;
}

const BVDatePicker: React.FunctionComponent<IBVDatePicker> = ({ className, errorMessage, infoMessage, label, properties, required, isEmbedded, isToShow }) =>
    <BVControl
        className={`bv-date-picker ${className}`}
        errorMessage={errorMessage}
        infoMessage={infoMessage}
        label={label}
        required={required}
    >
        {
            isEmbedded ?
            <DatePicker
                style={{maxWidth: "unset"}}
                {...properties}
                open={isToShow}
            /> :
            <DatePicker
                style={{maxWidth: "300px"}}
                {...properties}
            />
        }
    </BVControl>;

export default BVDatePicker;